import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
const BookTrialClass = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    fitnessGoal: 'What is your fitness goal?',
    location: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="containers free-trail" >
      <div className="row">
        <div className="col-md-6">
          <h1  className='booktxt'>Book Your Free Trial Class Today!</h1>
          <p className='paratxt'>
            Join us TODAY at the AimFit studios or online with the AimFit app.
          </p>
         
        </div>
        <div className="col-md-6">
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col">
                <input
                  type="text"
                  className="form-control inputwidth"
                  placeholder="Your full name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col">
                <input
                  type="text"
                  className="form-control inputwidth"
                  placeholder="Phone Number"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="mb-3">
              <select
                className="form-control widthSelect"
                name="fitnessGoal"
                value={formData.fitnessGoal}
                style={{
                  color: formData.timeSlot ? "black" : "black", 
                 
                  fontStyle:'italic'
                }}
                onChange={handleChange}
              >
                <option>Select fitness goal?</option>
                <option>Lose weight</option>
                <option>Build muscle</option>
                <option>Improve endurance</option>
                <option>General fitness</option>
              </select>
            </div>
            <div className="mb-3">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="location "
                  id="studio"
                  value="studio"
                  checked={formData.location === 'studio'}
                  onChange={handleChange}
                />
                <label className="form-check-label paratxt" htmlFor="studio">
                  Studio
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="location "
                  id="online"
                  value="online"
                  checked={formData.location === 'online'}
                  onChange={handleChange}
                />
                <label className="form-check-label paratxt" htmlFor="online">
                  Online
                </label>
              </div>
            </div>
            <button type="submit" className="btn" >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookTrialClass;
